// extracted by mini-css-extract-plugin
export default {"title":"LrnV5","fixedAtTop":"_WcG3","multiSelectHeader":"XiaS0","leftIconStyle":"RsWIV"};